import { View, Text } from "react-native";
import { AppFontStyle } from "../styles/AppFontStyle";
import { AppColors } from "../utility/AppColors";
import { useCallback } from "react";
import React from "react";

export const CommonProgressbar = (props: any) => {
  const { percentage = 0 } = props;

  const getBackgroundColor = useCallback((percentage) => {
    if (percentage <= 35) {
      return AppColors.red_FF2727;
    } else if (percentage <= 70) {
      return AppColors.yellow_E4AB3C;
    } else {
      return AppColors.appGreenColor_51AF07;
    }
  }, []);

  return (
    <View
      style={[
        {
          backgroundColor: getBackgroundColor(percentage),
          height: 10,
          borderRadius: 8,
          marginTop: 10,
          width: `${percentage}%`,
          bottom: 10,
        },
      ]}
    >
      <Text
        style={[
          AppFontStyle.REGULAR_ANYBODY_8,
          {
            color: AppColors.white,
            textAlign: percentage === 100 ? "center" : "right",
            paddingTop: 1,
            minWidth: 12,
          },
        ]}
      >
        {percentage} %
      </Text>
    </View>
  );
};
